import { IInitializeReturn } from '@smiles/voebiz-core-engine/dist/types';
import React, { FC, createContext, useCallback, useContext, useEffect, useState } from 'react';
import { init } from 'services/config/initCore';

const coreDefault = {} as IInitializeReturn;

const CoreContext = createContext<Partial<IInitializeReturn>>(coreDefault);

const CoreProvider: FC<{ children: JSX.Element }> = ({ children }) => {
  const [coreInitialized, setCoreInitialized] = useState(false);

  const [core, setCore] = useState<IInitializeReturn>();


  const handleInit = useCallback(async () => {
    const response = await init();
    setCore(response);
    const success = response?.success ?? false;
    if (success) {
      setCoreInitialized(success);
    }
  }, []);

  useEffect(() => {
    handleInit();
  }, [handleInit]);

  if (!coreInitialized) {
    return null;
  }

  return <CoreContext.Provider value={core}>{children}</CoreContext.Provider>;
};

const useCore = () => {
  const core = useContext(CoreContext);

  if (!core) {
    throw new Error('Cannot use `useCore` outside of CoreProvider');
  }
  return core;
};

export { CoreContext, CoreProvider, useCore };
